<template>
  <div>
    <div class="row">
      <div
        class="col-lg-4"
        style="margin-bottom: 30px;"
      >
        Prazo para resposta:
        <div style="margin-top: 10px;">
          <days-since-the-infraction-pill
            :analysis-due-date="infractionData.analysis_due_date"
            size="md"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 col-sm-12">
        <div class="row">
          <tr-read-only-text-field
            class="col-lg-7 col-sm-6"
            label="Nome do pagador:"
            content-text-variant="h5"
            :value="infractionData.payer_name"
          />
          <tr-read-only-text-field
            class="col-lg-5 col-sm-6"
            label="Documento:"
            content-text-variant="h5"
          >
            {{ formatCpfCnpj(infractionData.payer_tax_id) }}
            <copy-clipboard-button
              type="inline"
              :text-to-copy="infractionData.payer_tax_id"
            />
          </tr-read-only-text-field>
        </div>
        <div class="row">
          <tr-read-only-text-field
            class="col-lg-4 col-sm-6"
            label="Valor da infração:"
            content-text-variant="h5"
            :value="centsToReal(infractionData.amount)"
          />
          <tr-read-only-text-field
            class="col-lg-4 col-sm-6"
            label="Status da contestação:"
            content-text-variant="h5"
            :value="formatAnalysisStatus(infractionData.analysis_status)"
          />
          <tr-read-only-text-field
            class="col-lg-4 col-sm-6"
            label="Tipo da infração:"
            content-text-variant="h5"
            :value="formatSituationType(infractionData.situation_type)"
          />
        </div>
        <div class="row">
          <tr-read-only-text-field
            class="col-lg-4 col-sm-6"
            label="Valor devolvido:"
            content-text-variant="h5"
            :value="infractionData.refund?.refunded_amount ? centsToReal(infractionData.refund?.refunded_amount) : '-'"
          />
          <tr-read-only-text-field
            class="col-lg-4 col-sm-6"
            label="Parecer Transfeera:"
            content-text-variant="h5"
            :value="formatStatus(infractionData.status)"
          />
          <tr-read-only-text-field
            class="col-lg-4 col-sm-6"
            label="Analisado por:"
            content-text-variant="h5"
            :value="infractionData.user?.name || '-'"
          />
        </div>
      </div>
      <div class="col-lg-4 col-sm-12">
        <div class="row">
          <tr-read-only-text-field
            class="col-lg-12 col-sm-6"
            label="Recebida em:"
            content-text-variant="h5"
            :value="formatDateTime(infractionData.infraction_date)"
          />
          <tr-read-only-text-field
            class="col-lg-12 col-sm-6"
            label="Data da efetivação da devolução:"
            content-text-variant="h5"
          >
            <bg-badge
              v-if="isInMonitoring"
              size="sm"
              color="yellow-light"
            >
              Devolução em monitoramento (90 dias)
            </bg-badge>
            <template v-else>
              {{ infractionData.refund?.refund_date ? formatDateTime(infractionData.refund?.refund_date) : '-' }}
            </template>
          </tr-read-only-text-field>
          <tr-read-only-text-field
            v-if="isInMonitoring"
            class="col-lg-12 col-sm-6"
            label="Data limite de monitoramento:"
            content-text-variant="h5"
            :value="infractionData.refund?.monitoring_end_date ? formatDateTime(infractionData.refund?.monitoring_end_date) : '-'"
          />
          <tr-read-only-text-field
            class="col-lg-12 col-sm-6"
            label="Status da devolução MED:"
            content-text-variant="h5"
            :value="infractionData.refund?.status ? formatRefundStatus(infractionData.refund?.status) : '-'"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div
        class="col-lg-7"
      >
        Descrição da infração
        <textarea
          v-model="infractionData.infraction_description"
          readonly
          class="textarea"
          rows="8"
        />
      </div>
      <div class="col-lg-5">
        <div class="row vertical-offset1">
          <bg-text
            type="h6"
            class="side-col-label"
          >
            ID da infração:
          </bg-text>
          <div class="side-col-value">
            {{ infractionData.id }}
            <copy-clipboard-button
              type="inline"
              :text-to-copy="infractionData.id"
            />
          </div>
        </div>
        <div class="row vertical-offset1">
          <bg-text
            type="h6"
            class="side-col-label"
          >
            E2E Pix:
          </bg-text>
          <div class="side-col-value">
            {{ infractionData.transaction_id }}
            <copy-clipboard-button
              type="inline"
              :text-to-copy="infractionData.transaction_id"
            />
          </div>
        </div>
        <div class="row vertical-offset1">
          <bg-text
            type="h6"
            class="side-col-label"
          >
            ID de integração:
          </bg-text>
          <div class="side-col-value">
            {{ infractionData.txid ? infractionData.txid : '-' }}
            <copy-clipboard-button
              v-if="infractionData.txid"
              type="inline"
              :text-to-copy="infractionData.txid"
            />
          </div>
        </div>
        <div class="row vertical-offset1">
          <bg-text
            type="h6"
            class="side-col-label"
          >
            Camada da infração:
          </bg-text>
          <div class="side-col-value">
            {{ infractionData.is_first_layer ? 'Primeira' : 'Segunda ou maior' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from '@transfeeradev/moment';
import DaysSinceTheInfractionPill from '@/apps/contestations/infractions/components/DaysSinceTheInfractionPill.vue';
import CopyClipboardButton from '@/commons/components/container/CopyClipboardButton.vue';
import { BgText, BgBadge } from '@transfeeradev/bridge';
import { formatDateTime } from '@/commons/formatters/formatDate';
import { centsToReal } from '@/commons/formatters/currency';
import formatCpfCnpj from '@/commons/formatters/cpfCnpj';
import infractionStatus from '@/apps/contestations/infractions/constants/infractionStatus';
import situationTypes from '@/apps/contestations/infractions/constants/situationTypes';
import analysisStatus from '@/apps/contestations/infractions/constants/analysisStatus';
import refundStatus from '@/apps/contestations/infractions/constants/refundStatus';

export default {
  name: 'infraction-details',
  components: {
    DaysSinceTheInfractionPill,
    BgText,
    BgBadge,
    CopyClipboardButton
  },
  props: {
    infractionData: {
      type: Object
    },
    isAnalysisFormVisible: {
      type: Boolean
    }
  },
  emits: ['show-analysis-form', 'back'],
  setup() {
    return {
      formatDateTime,
      centsToReal,
      formatCpfCnpj
    };
  },
  data() {
    return {
      showButton: true
    };
  },
  computed: {
    isInMonitoring() {
      const monitoringEndDate = moment(this.infractionData?.refund?.monitoring_end_date);
      return this.infractionData?.refund?.status === 'pending' && moment().isBefore(monitoringEndDate);
    }
  },
  methods: {
    emitShowAnalysisForm() {
      this.$emit('show-analysis-form', true);
    },
    formatSituationType(situationType) {
      return situationTypes[situationType];
    },
    formatStatus(status) {
      return infractionStatus[status];
    },
    formatAnalysisStatus(status) {
      return analysisStatus[status];
    },
    formatRefundStatus(status) {
      return refundStatus[status];
    },
    onBack() {
      this.$emit('back');
    }
  }
};
</script>

<style scoped>
.textarea {
  font-family: inherit;
  border: 1px solid var(--bg-grey-semi-light);
  border-radius: 8px;
  box-sizing: border-box;
  background-color: var(--bg-grey-light);
  color: var(--bg-grey-semi-dark);
  padding: 16px;
  resize: vertical;
  width: 100%;
}

.side-col-label {
  font-size: 14px !important;
}

.side-col-value {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 16px;
}
</style>
